export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer__copyright">&copy; {new Date().getFullYear()} Around The U.S.</p>
    </footer>
  );
}
